module.exports = __webpack_public_path__ + "img/dstv-error-fix-4.7f2d55d8.jpg";